export const GET_ALL_CHARACTERS = "https://rickandmortyapi.com/api/character";
